<template>
	<v-container fluid>
		<div v-if="isLoaded">
			
			<!--resources table head-->
			<v-divider class="mt-4" color="black" />
			<v-row class="subtitle-2" no-gutters>
				<v-col v-for="(item, i) in headers" :key="i"
					class="text-pre-wrap"
					:class="item.style">
					{{ `${item.title}` | localize }}
				</v-col>
			</v-row>
			<v-divider class="mt-4" color="black" />
			
			<!-- resources tab -->
			<div v-if="resources?.length > 0">
				
				<v-row v-for="resource in resources" 
					:key="resource.id" class="body-2" no-gutters>
					<v-col class="text-left">{{ formatNumber(resource.capacities) }}</v-col>
					<v-col v-if="productionPlan > resource.capacities" 
						class="text-center error--text">
						{{ formatNumber(productionPlan) }}
						<v-btn color="secondary" icon>
							<v-tooltip bottom color="error">
								<template v-slot:activator="{ on, attrs }">
									<v-icon small v-on="on" v-bind="attrs">
										mdi-alert-circle
									</v-icon>
								</template>
								<span>you don't have enough capacities!</span>
							</v-tooltip>
						</v-btn>
					</v-col>
					<v-col v-else class="text-center">{{ formatNumber(productionPlan) }}</v-col>
					<v-col class="text-center">{{ formatNumber(resource.capacities_increase) }}</v-col>
					<v-col class="text-center">{{ formatNumber(resource.long_term_debt) }}</v-col>
					<v-col class="text-center">{{ formatNumber(resource.borrowings) }}</v-col>
					<v-col class="text-center">{{ formatNumber((resource.long_term_debt + resource.borrowings) * 0.09) }}</v-col>      
					<v-col class="text-center">{{ selializing(resource.research_segments) }}</v-col>
					<v-col class="text-center">{{ formatNumber(resource.research_costs) }}</v-col>
					<v-col class="text-center">
						<edit-resources :resource="resource" />
					</v-col>
				</v-row>
				<v-divider />
			</div>
			<v-row v-else class="mt-8 px-4">
				You haven't resources yet!
			</v-row>
		</div>
		<!--Loader -->
		<v-row v-else justify="center" class="mt-12">
			<loader />
		</v-row> 
	</v-container>
</template>
<script>

import EditResources from '../../../components/team/resources/editResource.vue';
import Loader from '../../../layouts/Loader.vue';
export default {
	data() {
		return {
			isLoaded: false,
			headers: [
				{ title: 'Capacities current round (units)', style: 'text-left' },
				{ title: 'Production plan current round (units)', style: 'text-center' },
				{ title: 'Capacities increase next round (units)', style: 'text-center' },
				{ title: 'Current long-term debt ($)', style: 'text-center' },
				{ title: 'Borrowings current round ($)', style: 'text-center' },
				{ title: 'Interests current round ($)', style: 'text-center' },
				{ title: 'Segments for research', style: 'text-center' },
				{ title: 'Research costs ($)', style: 'text-center' },
				{ title: 'Actions', style: 'text-center' },
			],
		}
	},
	computed: {
		locale() {
			return this.$store.getters.locale;
		},
		team() {
			return this.$store.getters.team;
		},
		game() {
			return this.$store.getters.game;
		},
		resources() {
			return this.$store.getters.resources_team;
		},
		finances() {
            return this.$store.getters.finances;
        },
		products() {
			return this.$store.getters.products;
		},
		productionPlan() {
			let res = 0;
			if (this.products?.length > 0) {
				res = this.products.reduce((sum, item) => {
					return sum+= item.production_plan;
				}, 0)
			}
			return res;
		}
	},
	methods: {
		formatNumber(num) {
			if (this.locale == 'ro-RO') {
				return num.toLocaleString('en-US')
			}
			return num.toLocaleString(this.locale)
		},
		getValue(val) {
			return this.values.find(v => v.value === val).text;
		},
		selializing(arr) {
			if (arr && arr.length) {
				return arr.join(', ');
			}
			return ''
		}
	},
	components: { EditResources, Loader },
	async created() {

		if (this.game && this.team) {

			const params = {
				gameId: this.game.id,
				round: this.game.round,
				teamId: this.team.id,
			}

			if (this.resources == null) { 
				try {
					await this.$store.dispatch('fetchTeamResources', params);
				} catch (error) {
					await this.$store.dispatch('setError', error.message)
				}
			}

			if (!this.finances) {
				try {
					await this.$store.dispatch('fetchTeamFinances', params);
				} catch (error) {
					await this.$store.dispatch('setError', error.message)
				}
			}

			if (this.products == null) {
				try {
					await this.$store.dispatch('fetchTeamProducts', params);
				} catch (error) {
					await this.$store.dispatch('setError', error.message)	
				}
			} 
		}

		this.isLoaded = true;
    }
}
</script>